import  {__extends} from './eXcell';
import eXcell_ch from './eXcell_ch';

var eXcell_ra = (function (_super) {
    __extends(eXcell_ra, _super);
    function eXcell_ra(a) {
        _super.call(this, a);
        this.grid = a.parentNode.grid;
    }
    eXcell_ra.prototype.disabledF = function (c) {
        if (c == true || c == 1) {
            this.cell.innerHTML = this.cell.innerHTML
                .replace("radio_chk0.", "radio_chk0_dis.")
                .replace("radio_chk1.", "radio_chk1_dis.");
        }
        else {
            this.cell.innerHTML = this.cell.innerHTML
                .replace("radio_chk0_dis.", "radio_chk0.")
                .replace("radio_chk1_dis.", "radio_chk1.");
        }
    };
    eXcell_ra.prototype.changeState = function (c) {
        if (c === false && this.getValue() == 1) {
            return;
        }
        if (!this.grid.isEditable ||
            this.cell.parentNode._locked ||
            this.isDisabled()) {
            return;
        }
        if (this.grid.callEvent("onEditCell", [
            0,
            this.cell.parentNode.idd,
            this.cell._cellIndex
        ]) != false) {
            this.val = this.getValue();
            if (this.val == "1") {
                this.setValue("0");
            }
            else {
                this.setValue("1");
            }
            this.cell.wasChanged = true;
            this.grid.callEvent("onEditCell", [
                1,
                this.cell.parentNode.idd,
                this.cell._cellIndex
            ]);
            this.grid.callEvent("onCheckbox", [
                this.cell.parentNode.idd,
                this.cell._cellIndex,
                this.val != "1",
                'radio'
            ]);
            this.grid.callEvent("onCheck", [
                this.cell.parentNode.idd,
                this.cell._cellIndex,
                this.val != "1",
                'radio'
            ]);
        }
        else {
            this.editor = null;
        }
        return true;
    };
    return eXcell_ra;
})(eXcell_ch);
eXcell_ra.prototype.setValue = function (c) {
    this.cell.style.verticalAlign = "middle";
    if (c) {
        c = c.toString()._dhx_trim();
        if (c == "false" || c == "0") {
            c = "";
        }
    }
    if (c) {
        if (!this.grid._RaSeCol) {
            this.grid._RaSeCol = [];
        }
        if (this.grid._RaSeCol[this.cell._cellIndex]) {
            var a = this.grid.cells(this.grid._RaSeCol[this.cell._cellIndex], this.cell._cellIndex);
            a.setValue("0");
            if (this.grid.rowsAr[a.cell.parentNode.idd]) {
                this.grid.callEvent("onEditCell", [
                    1,
                    a.cell.parentNode.idd,
                    a.cell._cellIndex
                ]);
            }
        }
        this.grid._RaSeCol[this.cell._cellIndex] = this.cell.parentNode.idd;
        c = "1";
        this.cell.chstate = "1";
    }
    else {
        c = "0";
        this.cell.chstate = "0";
    }
    this.cell.setAttribute("excell", "ra");


    let checkCls=c==="0"?"ivu-icon ivu-icon-md-radio-button-off":"ivu-icon ivu-icon-md-radio-button-on";
    this.setCValue(`<span class="grid_check_box" onclick='new eXcell_ra(this.parentNode).changeState(true); (arguments[0]||event).cancelBubble=true; '  title=""><i  class="radio_icon ${checkCls}"></i></span>`, this.cell.chstate);


};
window.eXcell_ra = eXcell_ra;
export default eXcell_ra;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_ra.js